export const ownerRole = 'CRMAccountOwner'
export const adminRoles = ['CRMAccountOwner', 'CRMAccountAdmin']
export const editorRoles = ['CRMAccountOwner', 'CRMAccountAdmin', 'CRMAccountUser']

export function roleLabel(role: string | null): string {
  switch (role) {
    case 'CRMAccountOwner':
      return 'Account owner'
    case 'CRMAccountAdmin':
      return 'Admin'
    case 'CRMAccountUser':
      return 'User'
    case 'ReadOnly':
      return 'Read only'
    default:
      return role ?? ''
  }
}
